import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { clsx } from 'clsx';

interface SeparatorProps {
    height?: number;
    className?: string;
    // 'menu' is the Grey Chalk seam between menu sections
    customColor?: 'grey' | 'lightGrey' | 'menu';
}

const Separator: FC<SeparatorProps> = ({ height = 8, className, customColor }): ReactElement => {
    const classes = useStyles();

    return (
        <div
            className={clsx('LCSeparator', classes.separatorContainer, classes[customColor], className)}
            style={{ minHeight: height }}
        />
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        separatorContainer: {
            width: '100%',
            backgroundColor: theme.palette.colors.background.separator,
        },
        grey: {
            backgroundColor: theme.palette.colors.text.label,
        },
        lightGrey: {
            backgroundColor: theme.palette.colors.background.menuSeparator,
        },
        menu: {
            backgroundColor: theme.palette.colors.background.separator,
        },
    }),
);

export default Separator;
